// Identity adapter (rollout PRD §4.1: "config.getIdentity()"). The one place the SDK learns who is
// using the app; everything else treats identity as opaque.
//
// Dipi's v1 login payload (`/api/session/check-login`) carries `customerID` and `username` but NO
// numeric user id — `@signals` `userID` reads an `id_user` that is never there. So:
//   - `user_id` on the envelope is sent as 0 and dipi-webback-v2 fills it server-side from the
//     session cookie (`_user_id`), which is the trustworthy source anyway (PRD §5, server-trusted
//     fields). When v1 starts returning `id_user`, the client value will simply agree with it.
//   - Session rotation and user_signed_in/out key on the username: it is what actually changes on
//     login/logout here. It never leaves the browser — it is a key, not a prop (no PII rule).

import { userData, userID, customerID } from "@signals"

// Stable key of the current identity, null when logged out. Used only to detect changes.
export function identityKey() {
    try { return userData.value?.username ?? null } catch { return null }
}

// The ids that ride on every envelope. null → the backend treats it as "fill it in".
export function identityIds() {
    try {
        return { user_id: userID.value ?? null, customer_id: customerID.value ?? null }
    } catch {
        return { user_id: null, customer_id: null }
    }
}
